import { CSSProperties, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
// import defaultTheme from '../../../assets/themes/main.json';
// import qualigenceTheme from '../../../assets/themes/qualigence.json';
import Icon from "../Icon/Icon";
import InputSelect from '../InputSelect/InputSelect';
import cookie from 'js-cookie'
import { changeClientId } from 'store/slices/client.slice';
export const DebugClient: React.FC<{}> = () => {
    const dispatch = useAppDispatch()
    const [selectCompany, setSelectCompany] = useState<any>(null)
    const [isOpen, setIsOpen] = useState(false)
    const data = useAppSelector(state => state.client.clientAdmin)
    const user = useAppSelector(state => state.user)
    useEffect(() => {
        const hasClientId = cookie.get('clientId')
        if (hasClientId) {
            if (hasClientId) {
                const selectedCompany = data.clients?.find(item => item.id === hasClientId)
                setSelectCompany({ label: selectedCompany?.name, value: selectedCompany?.id })
            }
        }
    }, [data.clients])
    const themeSchemas = {
        // default: qualigenceTheme,
        // qualigence: defaultTheme
    }

    return user.data.isCoordinator ? <div style={(themeSchemas) as CSSProperties}>
        <div className={`p-2 !z-[9999999999] rounded-full rounded-bl-none rounded-tl-none bg-gray-900 fixed top-16 justify-center w-fit flex gap-4 transition-all duration-200 pl-6 ${isOpen ? '-left-0 ring-1 ring-primary-600' : '-left-[229px]'} items-center`}>
            <Icon name="company" size={15} className='text-white-500' />
            <div className="min-w-[160px] max-w-[160px]">
                <InputSelect
                    isMulti={false}

                    options={data.clients?.map(item => ({ label: item.name, value: item.id })) as any || []}
                    setState={async (value: any) => {
                        if (value === null) {
                            cookie.remove('clientId')

                            setSelectCompany(null)
                            document.location.reload()
                            return
                        }
                        
                        try {
                            await dispatch(changeClientId({ userId: user.data.userId, clientId: value.value })).unwrap()
                            setSelectCompany(value)
                            setIsOpen(false)
                            cookie.set('clientId', value.value, { expires: 365 })
                            document.location.reload()
                        } catch (error) {
                            console.error('Erro ao atualizar client ID:', error)
                            // Opcional: mostrar uma mensagem de erro para o usuário
                        }
                    }}

                    placeholder="Select Value" variant="light"
                    state={selectCompany}
                />
            </div>
            <button className=" text-white-500 flex items-center gap-2 p-2 rounded-full hover:bg-gray-700 w-7 h-7" onClick={() => { setIsOpen(e => !e) }}>
                {isOpen ? <Icon name="chevron-left" size={12} /> : <Icon name="chevron-right" size={12} />}
            </button>
        </div>
    </div> : null;
}